import React, { Component } from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../../modals/redux/modalActions';

const actions = {
  closeModal,
};

class ModalImagePopup extends Component {
  render() {
    const { data, closeModal } = this.props;
    const url = data;
    return (
      <div className='modal is-active'>
        <div className='modal-background' onClick={closeModal}></div>
        <div
          className='modal-content'
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
          }}
        >
          <div
            className='image has-text-centered'
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'none',
            }}
          >
            <img
              src={url}
              alt='preview'
              style={{
                display: 'block',
                objectFit: 'contain',
                maxWidth: '90vw',
                maxHeight: '90vh',
                width: 'auto',
                height: 'auto',
              }}
              onLoad={(e) => {
                const img = e.target;
                img.style.width =
                  img.naturalWidth > window.innerWidth * 0.9
                    ? '90vw'
                    : img.naturalWidth + 'px';
                img.style.height =
                  img.naturalHeight > window.innerHeight * 0.9
                    ? '90vh'
                    : img.naturalHeight + 'px';
              }}
            />
          </div>
        </div>
        <button
          className='modal-close is-large'
          aria-label='close'
          onClick={closeModal}
        ></button>
      </div>
    );
  }
}

export default connect(null, actions)(ModalImagePopup);
